import { Component, Input } from '@angular/core';
import { ContactPerson } from '../../models/contact';
import { AvatarComponent } from '../../../../components/avatar/avatar.component';
import { ContactRowsComponent } from '../contact-rows/contact-rows.component';
import { TransportModeIconPipe } from '../../../../pipes/transport-mode-icon.pipe';
import { TransportMode } from '../../../../models/shipment';

// Same product names as the "dept-product" combobox (add-department-contact.component.html) —
// department names are built as "<Product> <Function> <Office>", so the icon is keyed off the
// name's first word rather than a dedicated field.
const TRANSPORT_MODES: TransportMode[] = ['Air', 'Courier', 'Ocean', 'Rail', 'Road'];
const transportModeIconPipe = new TransportModeIconPipe();

@Component({
  selector: 'app-department-item',
  standalone: true,
  imports: [AvatarComponent, ContactRowsComponent],
  templateUrl: './department-item.component.html',
  styleUrl: './department-item.component.scss'
})
export class DepartmentItemComponent {
  @Input() department: ContactPerson | null = null;

  get transportIconUrl(): string | null {
    const firstWord = this.department?.name?.trim().split(/\s+/)[0];
    const mode = firstWord && TRANSPORT_MODES.find(candidate => candidate.toLowerCase() === firstWord.toLowerCase());
    return mode ? transportModeIconPipe.transform(mode) : null;
  }
}
